'use client';

import React, { useState, RefObject } from 'react';
import { useVirtual } from 'react-virtual';
import { createGlobalStyle } from 'styled-components';
import { Box, BoxProps } from '../../wag-react/next-components/box';

// Hide the scrollbar to avoid unexpected UI issue with it
const GlobalStyle = createGlobalStyle`
  .virtual-list-container::-webkit-scrollbar {
    /* Chrome, Safari */
    display: none;
  }
  .virtual-list-container {
    /* Firefox */
    scrollbar-width: none;
  }
`;
export type VirtualListProps = {
  items: unknown[];
  itemHeight?: number;
  parentRef: RefObject<HTMLElement | null>;
  virtualizer: ReturnType<typeof useVirtual>;
} & BoxProps;
export const VirtualList = ({
  children,
  items,
  itemHeight = 400,
  parentRef,
  virtualizer,
  ...rest
}: VirtualListProps) => {
  /**
   * Set a container height that will only be evaluated ONCE during the lifetime
   * of this component. This doesn't change on succeeding render of this component
   *
   * It is important to determine the height of the container
   * ONCE to avoid CLS issue
   *
   * 400px is the minimum height per item
   */
  const [containerHeight] = useState(() => items.length ? `${items.length * itemHeight}px` : 0);
  return <>
      <GlobalStyle data-sentry-element="GlobalStyle" data-sentry-source-file="index.tsx" />
      <Box className="virtual-list-container" ref={parentRef} height={containerHeight} width="100%" overflow="auto" {...rest} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box height={`${virtualizer.totalSize}px`} position="relative" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          {children}
        </Box>
      </Box>
    </>;
};